import { PaginationModel } from '../models/pagination.model';

export const DefaultPaginationModel: PaginationModel = {
  pageSize: 10,
  current: 1,
  total: 0,
  pageSizeOptions: ['10', '20', '30', '50', '100'],
  defaultCurrent: 1,
  defaultPageSize: 10,
};

export const EventsPageSizeOptions = [50, 100, 200];






